import type { Resource } from '@frameio/graphql-client/generated';
import { useGetResourcesGrantingAccessQuery } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { DEFAULT_INITIAL_PAGE_SIZE } from '@frameio/utils';

type GetResourcesGrantingAccessArgs = {
  fetchData?: boolean;
  id: Resource['id'];
};

export const useGetResourcesGrantingAccess = ({
  fetchData = false,
  id,
}: GetResourcesGrantingAccessArgs) => {
  const accountId = useActiveAccountId();
  const { data, refetch, loading } = useGetResourcesGrantingAccessQuery({
    variables: {
      accountId: accountId ?? '',
      id,
      page: { first: DEFAULT_INITIAL_PAGE_SIZE },
    },
    skip: !fetchData || !accountId,
  });

  const resources = data?.account?.resource?.accessGrantingResources
    ?.nodes as Array<Resource>;
  const resourcesGrantingAccessData = resources?.filter(
    (resource) => resource.memberCount > 0 && resource.id !== id
  );

  return {
    resourceType: data?.account?.resource?.__typename,
    refetchResourcesGrantingAccess: refetch,
    resourcesGrantingAccess:
      resourcesGrantingAccessData?.length > 0
        ? resourcesGrantingAccessData
        : undefined,
    loading,
  };
};
